module.exports = __webpack_public_path__ + "img/img7.ebe7b8a1.png";